












































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Dialog from '../Dialog/index';
import Warning from '../Warning/index';

@Component({})
export default class Sider extends Vue {
    get info(): object {
        return this.$store.state.app.info;
    }
    get showInfo(): boolean {
        return this.$store.state.app.showInfo;
    }
    get isAuthor(): boolean {
        return this.$store.state.app.isAuthor;
    }
    signIn(): void {
        let self = this;
        Dialog.open({
            showInput: true,
            inputPlaceholder: '请输入accesstoken',
            confirmButtonText: '登陆',
            confirmCallBack: async function (accesstoken: string) {
                if (accesstoken === '' || !accesstoken) {
                    Warning.info('accesstoken不能为空！');
                } else {
                    await self.$store.dispatch('accesstoken', {accesstoken});
                    let accessInfo = self.$store.state.app.accessInfo;
                    console.log(accessInfo);
                    if (accessInfo.success) {
                        self.$store.dispatch('changeAccesstoken', {accesstoken});
                        await self.$store.dispatch('getMessage', {accesstoken,
                            mdrender: true
                        });
                        await self.$store.dispatch('getInfo', {
                            username: accessInfo.loginname
                        });
                        Dialog.close();
                        Warning.info('登录成功！');
                        window.localStorage.setItem('accesstoken', accesstoken);
                        setTimeout(() => {
                            window.location.reload();
                        }, 1000);
                    } else {
                        Warning.info('accesstoken不正确，请重新输入！');
                    }
                }
            },
            cancelCallBack(accesstoken: string) {
                Dialog.close();
            },
        });
    }
};
